import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"

import Breadcrumb from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import "./eng-payment.scss"

import { Layout, Button, Row, Col, notification, Space } from "antd"
const { Content } = Layout
import EngPaymentList from "./eng-payment-list"
notification.config({
  duration: 1,
  rtl: true,
})
const Index = props => {
  const { countSelectedProject, triggerReload } = props
  const [api, contextHolder] = notification.useNotification()
  const [errorMessage, setErrorMessage] = useState(null)
  const [idEngineer, setIdEngineer] = useState(null)
  const openNotification = (type, placement, message) => {
    api[type]({
      message,
      placement,
    })
  }

  const contentStyle = {
    backgroundColor: "#fff",
    margin: 2,
    paddingInline: 2,
    borderRadius: 2,
  }

  return (
    <>
      <MetaTags>
        <title>واحد گاز | پرداختی</title>
      </MetaTags>

      {contextHolder}
      <EngPaymentList
        openNotification={openNotification}
        reload={triggerReload}
      />
    </>
  )
}

const mapStateToProps = ({ EngPayment }) => ({
  triggerReload: EngPayment.triggerReload,
})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Index))
